import {BModal} from "bootstrap-vue";

export default {
    components: {
        BModal
    },
    props: ['data']
}
